import UserFriendlyError from './UserFriendlyError';

/**
 * Error message that can safely be displayed to the user.
 */
export default class FetchFailedError extends UserFriendlyError {

  constructor(message = 'You are not allowed to perform this action.', ...args) {

    // noinspection JSCheckFunctionSignatures
    super(message, ...args);

  }

}


// WEBPACK FOOTER //
// ./src/errors/FetchFailedError.js